import React from "react"

const CallToAction = () => {
  return <div>call to action</div>
}

export default CallToAction
